import { createStore } from 'vuex'

export default createStore({
  state: {
    load: false,
    user: {
      nick: "",
      id: 0
    },
    expired: 0,
  },
  getters: {
  },
  mutations: {
    setLoad(state, status) {
      state.load = status
    },
    setUser(state, payload) {
      state.user.id = payload.id
      state.user.nick = payload.nick
    },
    setExpired(state, payload) {
      state.expired = payload
    },
  },
  actions: {
  },
  modules: {
  }
})
